export const API_URL = "https://api.reviewalert.com";
export const WEBCHAT_API_URL = "https://chat.reviewalert.com/api/v1";
export const HOME_CHAT_S3_URL = "https://reviewalert-widget.s3.amazonaws.com/home-webchat/static/js/main.js"
export const HOME_BEACON_S3_URL = "https://reviewalert-widget.s3.amazonaws.com/home-beacon/static/js/main.js"
export const WEBCHAT_REPAIR_S3_URL = "https://reviewalert-widget.s3.amazonaws.com/webchat-repair/static/js/main.js"
